/* Gesicht auf Socken – Kollektionsseite: Sortierung bei Auswahl sofort absenden,
   aktiven Chip in waagerecht scrollenden Chip-Reihen (Handy) ins Bild holen. */
(function () {
  document.querySelectorAll('form[data-sh-sort] select[name="sort_by"]').forEach(function (select) {
    // Filter in der Adresse (z. B. Preis aus den Budget-Knöpfen der Kopfzeile) bleiben beim Sortieren erhalten
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Kissen: Stil-Auswahl über dem Raster blendet die Karten der anderen Stile aus
  document.querySelectorAll('[data-sh-kfilter]').forEach(function (group) {
    var btns = group.querySelectorAll('[data-kstil]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var want = btn.getAttribute('data-kstil');
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        document.querySelectorAll('[data-sh-grid] > .sh-coll__item[data-kstil]').forEach(function (li) {
          li.hidden = !!want && li.getAttribute('data-kstil') !== want;
        });
      });
    });
  });

  // „Mehr laden“: nächste Seite holen und die Produkte anhängen, statt die Seite neu zu laden
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-sh-next]');
    if (!link || !window.fetch || !window.DOMParser) return;
    var grid = document.querySelector('[data-sh-grid]');
    var nav = link.closest('[data-sh-more]');
    if (!grid || !nav) return;
    e.preventDefault();
    if (link.classList.contains('is-loading')) return;
    link.classList.add('is-loading');
    link.setAttribute('aria-busy', 'true');
    link.textContent = 'Wird geladen …';
    fetch(link.href, { credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('[data-sh-grid] > .sh-coll__item');
        var first = null;
        Array.prototype.forEach.call(items, function (item) {
          var node = document.importNode(item, true);
          grid.appendChild(node);
          if (!first) first = node;
        });
        var newNav = doc.querySelector('[data-sh-more]');
        var shown = nav.querySelector('[data-sh-shown]');
        var bar = nav.querySelector('[data-sh-progress]');
        if (newNav) {
          var newShown = newNav.querySelector('[data-sh-shown]');
          var newBar = newNav.querySelector('[data-sh-progress]');
          var newNext = newNav.querySelector('[data-sh-next]');
          if (shown && newShown) shown.textContent = newShown.textContent;
          if (bar && newBar) bar.style.width = newBar.style.width;
          if (newNext) {
            link.href = newNext.href;
            link.textContent = 'Mehr laden';
            link.classList.remove('is-loading');
            link.removeAttribute('aria-busy');
          } else {
            link.remove();
          }
        } else {
          link.remove();
        }
        // Fokus auf das erste neue Produkt, damit Tastatur und Screenreader weitermachen können
        var focusLink = first && first.querySelector('a[href]');
        if (focusLink) focusLink.focus({ preventScroll: true });
      })
      .catch(function () {
        window.location.href = link.href;
      });
  });

  document.querySelectorAll('.sh-coll__bar .sh-chips').forEach(function (row) {
    var active = row.querySelector('[aria-current="page"]');
    if (!active || row.scrollWidth <= row.clientWidth) return;
    var rowBox = row.getBoundingClientRect();
    var box = active.getBoundingClientRect();
    if (box.left < rowBox.left || box.right > rowBox.right) {
      row.scrollLeft += box.left - rowBox.left - 16;
    }
  });
})();
